import {
  aCreateInsightResolution,
  anInsightResolution,
  mockCreateInsightResolutionMutationOperationMutation,
} from '__generated__';

export const handlers = [
  mockCreateInsightResolutionMutationOperationMutation((_req, res, ctx) => {
    const {
      fields: { name, description },
    } = _req.variables;

    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        createInsightResolution: aCreateInsightResolution({
          data: {
            ...anInsightResolution(),
            name: name ?? anInsightResolution().name,
            description: description ?? anInsightResolution().description,
            subResolutions: [],
          },
        }),
      })
    );
  }),
];
